import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import { ScopusIdChangeForm } from '@/module/Dashboard/components/ScopusIdChangeForm';
import { useChangeScopusId } from '@/module/Dashboard/model/DashboardQuery';
import { ScopusIdChangeRequest } from '@/module/Dashboard/model/DashboardTypes';

import { useAppNotification } from '@feature/utils';

interface ScopusIdChangeButtonProps {
  scopusId: string | null;
}

export function ScopusIdChangeButton({ scopusId }: ScopusIdChangeButtonProps) {
  const { mutate, isPending } = useChangeScopusId();
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);
  const notification = useAppNotification();

  const handleChange = (request: ScopusIdChangeRequest) =>
    mutate(request, {
      onError: notification.error,
      onSuccess: () => {
        notification.success();
        close();
      },
    });

  return (
    <>
      <Button
        variant="outline"
        loading={isPending}
        onClick={open}
      >
        {t('scopus.changeScopusId')}
      </Button>
      {opened && (
        <ScopusIdChangeForm
          onClose={close}
          isSubmitting={isPending}
          onChange={handleChange}
          scopusId={scopusId ?? ''}
        />
      )}
    </>
  );
}
